import React, { forwardRef, useCallback, useEffect, useState } from 'react'
import { Select } from 'antd'
import { AntdFormItem, AntdFormItemProps } from '@/common/components/AntdForm/AntdFormItem.tsx'
import { cn } from '@/utils/style.ts'
import { SelectGroupOption, SelectOption } from '@/common/types/components.def.ts'
import { uniqBy } from 'lodash-es'

type ComboBoxInputProps = React.ComponentProps<typeof Select> & {
  options: (SelectOption | SelectGroupOption) []
}

type AntdFormComboBoxProps = React.ComponentProps<typeof Select> & {
  options: (SelectOption | SelectGroupOption) []
} & AntdFormItemProps

export const ComboBoxInput: React.FC<ComboBoxInputProps> = ({ ref, className, options: rawOptions, ...props }) => {
  const [options, setOptions] = useState(rawOptions)

  const updateUserInputOption = useCallback((val: string | string[]) => {
    setOptions(prev => {
      if (val && !prev.map(x => x.value).includes(val)) {
        if (typeof val === 'string') {
          return uniqBy([{ label: val, value: val }, ...rawOptions], x => x.value)
        } else {
          return uniqBy([...val.map(x => ({ label: x, value: x })), ...rawOptions], x => x.value)
        }
      } else {
        return prev
      }
    })
  }, [rawOptions])

  useEffect(() => {
    updateUserInputOption(props.value as string)
  }, [props.value, updateUserInputOption])

  return (
    <Select
      {...props}
      ref={ref}
      allowClear={props.allowClear ?? true}
      className={cn('w-full', className)}
      options={[{ label: 'Input or Select', value: undefined, disabled: true }, ...options]}
      showSearch
      onSearch={updateUserInputOption}
      onClear={() => setOptions(rawOptions)}
    />
  )
}

export const AntdFormComboBox: React.FC<AntdFormComboBoxProps> = forwardRef(({
  fieldProps,
  ...props
}, ref) => {

  return (
    <AntdFormItem {...fieldProps}>
      <ComboBoxInput ref={ref} {...props} />
    </AntdFormItem>
  )
})

